import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=7fc5bb72"
import script from "./menus.js?vue&type=script&lang=js&external"
export * from "./menus.js?vue&type=script&lang=js&external"
import style0 from "./menus.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports